import { createDOMElement } from '../../../helpers/fixtureUtils';
import './index.scss';
import { ASSETS_IMAGES_BASE_URL } from '../../../constants/AssetConstants';
import { PRIVATE_EVENTS, PUBLIC_EVENTS, EVENT_CALLBACK } from '../../../handlers/EventManager/constants';
import FixtureService from '../../../services/FixturesService';
import { JSON_IMAGE_BASE_URL } from '../../../constants/FixtureConstants';
import { convertName, convertTime } from '../../../helpers/fixtureUtils';
import playImage from '../../../images/play-white.png';
import notifyImage from '../../../images/notification_unfilled.svg';
import tickImage from '../../../images/Tick.png';
const SI_IMAGE_URL = 'https://sportz.sonyliv.com/cricket/images/flags/rect/';
const SI_IMAGE_URL_TENNIS = `https://sportz.sonyliv.com/tennis/flags/`

export default class AllSportsTabView {
    constructor(sportsManager, fullPageFixturesConfig) {
        this.sportsManager = sportsManager;
        this.fullPageFixturesConfig = fullPageFixturesConfig;
        this.assetConfig = this.fullPageFixturesConfig?.assetConfig;
        if (!this.sportsManager) {
            throw new Error('Sports manager is required in soccer tab view.');
        }

        this.eventManager = this.sportsManager.eventManager;
        if (!this.eventManager) {
            throw new Error('Event manager is required in soccer tab view.');
        }
        
        this.fixtureData = null;
        this.fixtureDropdownData = [];
        this.fixtureStatus = 'concluded';
        this.currentPage = 0;
        this.previousPageNo = 0;
        this.totalPages = null;
        this.isLoadingMore = false;
        this.dropDownTourName = "";
        this.subscribeToEvents();
        this.scrollHandler = this.scrollHandler.bind(this);
        this.registerPaginationOnScroll();
        this.elementStore = {}
    }

    subscribeToEvents() {
        this.eventManager.subscribeToEvents({
            eventType: EVENT_CALLBACK.PRIVATE_EVENTS,
            eventCallback: this.privateEventCallback.bind(this),
            senderName: 'FIXTURE_SERVICE',
        });
    }
    unSubscribeToEvents() {
        this.eventManager.unSubscribeToEvents(
            'FIXTURE_SERVICE',
        );
    }
    getFixtureData(parentContainer, handleCTAClick, reminderIds, sportId, tourId, widgetCallback, jsonConfig, assetConfig) {
        this.parentContainer = parentContainer
        this.handleCTAClick = handleCTAClick
        this.reminderIds = reminderIds
        this.widgetCallback = widgetCallback
        this.jsonConfig = jsonConfig
        this.handleDropDownClick = assetConfig?.handleDropDownClick
        if (assetConfig?.status) {
            this.fixtureStatus = assetConfig.status == 'all' ? 'concluded' : assetConfig.status
        }
        this.renderFallbackConcluded = assetConfig?.renderFallbackConcluded
        this.fixtureService = new FixtureService(this.sportsManager);

        if(!sportId || !tourId) {
            this.eventManager.broadcastPublicEvent(PUBLIC_EVENTS.SPORTS_MANAGER_ERROR, {
                errorCode: 'err_100',
                errorMessage: 'Sports id and tournament is required in soccer tab view.',
              });
        }
        this.sportId = sportId
        this.tourId = this.getParamsValue('tour') || tourId;
        this.elementStore = {};
        this.fixtureService.fetchFixtureData(this.sportId, this.tourId, this.fixtureStatus, this.currentPage, PRIVATE_EVENTS.FULL_PAGE_FIXTURE_UPDATE, this.jsonConfig);
    }

    loadMoreItems= () => {
        if(this.previousPageNo !== this.currentPage) {
            this.fixtureService.fetchFixtureData(
                this.sportId, this.tourId, this.fixtureStatus, this.currentPage, PRIVATE_EVENTS.FULL_PAGE_FIXTURE_UPDATE, this.jsonConfig
            );
        }
    }

    getParamsValue(param) {
        let currentURL = new URL(window.location.href);
        let searchParams = new URLSearchParams(currentURL.search);
        return searchParams.get(param) || '';
    }

    privateEventCallback(eventName, eventData) {
        switch (eventName) {
            case PRIVATE_EVENTS.FULL_PAGE_FIXTURE_UPDATE: {
                this.fixtureData = eventData?.fixtureWidgetData;
                this.fixtureDropdownData = eventData?.fixtureDropdownData;
                this.tourMetaData = eventData?.tourMetaData;
                this.tourName = eventData?.tourName
                this.previousPageNo = this.currentPage
                this.currentPage = eventData.loadedPageNumber >= 0 ? (eventData?.loadedPageNumber + 1) : this.currentPage;
                this.totalPages = eventData?.totalPages;
                if(typeof eventData?.callback == 'function') {
                    eventData.callback()
                }
                this.render();
                this.isLoadingMore = false;
                break;
            }

            default: {
                console.log('Uncaught event');
                break;
            }
        }
    }

    createElement(parent, className, id, innerHTML) {
        const dom = {
            ele: "div",
            attributes: {
                class: className,
            },
            parent,
            innerHTML
        }

        if(id){
            dom.attributes.id = id;
        }

        const element = createDOMElement(dom);
        if (id) {
            this.elementStore[id] = element;
        }
        return element;
    }

    toggleMatchCard() {
        let specificDiv = document.querySelectorAll(`[tournment=${this.textContent}]`)
    }

    renderDropDown = (soccerTopLevelCont) => {
        const dropDownArray = this.fixtureDropdownData;

        const tournmentSelectWrapper = document.createElement("div");
        tournmentSelectWrapper.setAttribute("id", "tournment-select-container");
        tournmentSelectWrapper.setAttribute("class", "tournment-select-wrapper");

        const selectDiv = document.createElement("div");
        selectDiv.setAttribute("class", "select");

        const selectTrigger = document.createElement("div");
        selectTrigger.setAttribute("class", "select__trigger");
        selectDiv.appendChild(selectTrigger);

        const span = document.createElement("span");
        // span.textContent = "All tournament";
        selectTrigger.appendChild(span);

        const logoImg = new Image();
        logoImg.src = `${ASSETS_IMAGES_BASE_URL}/Chevron_down.png`;

        const dropdownArrow = document.createElement("div");
        dropdownArrow.setAttribute("class", "dropdownArrow");
        selectTrigger.appendChild(dropdownArrow);
        dropdownArrow.appendChild(logoImg);

        const innerCustomOptions = document.createElement("div");
        innerCustomOptions.setAttribute("class", "inner-custom-options display-none");
        selectDiv.appendChild(innerCustomOptions);

        const innerCustomOptionsMob = document.createElement("div");
        innerCustomOptionsMob.setAttribute("class", "mob-option display-none");
        const iconDiv = document.createElement("div");
        iconDiv.setAttribute("class", "mob-option-icon");
        const chevronImg = new Image();
        chevronImg.src = `${ASSETS_IMAGES_BASE_URL}/Chevron_down.png`;
        iconDiv.appendChild(chevronImg);
        innerCustomOptionsMob.appendChild(iconDiv);
        const headingDiv = document.createElement("div");
        headingDiv.setAttribute("class", "mob-option-heading");
        headingDiv.innerText="Select Tournament";
        innerCustomOptionsMob.appendChild(headingDiv);
        tournmentSelectWrapper.appendChild(innerCustomOptionsMob)

        selectTrigger.addEventListener("click", (e) => {
            e.stopPropagation();
            innerCustomOptions.classList.toggle("display-none");
            innerCustomOptionsMob.classList.toggle("display-none");
            logoImg.classList.toggle("dropdownArrowExpand");
            const overlay = document.getElementsByClassName('overlay')[0]
            overlay?.classList.toggle("display-none");

            if (overlay && !overlay.classList.contains("display-none")) {
                document.body.style.overflow = 'hidden'; // Make body unscrollable
            } else {
                document.body.style.overflow = 'auto'; // Restore body scroll
            }
        });

        dropDownArray?.forEach((item, index) => {
            let me = this;
            const customOption = document.createElement("span");
            customOption.setAttribute("class", "custom-option");
            customOption.setAttribute("value", item.tourId);
            customOption.setAttribute("id", `dropdown${index}`);
            // customOption.textContent = item.tourName === "all" ? "All tournament" : item.tourName;
            customOption.textContent = item.tourName;
            if (item.tourId == this.tourId) {
                customOption.classList.add("selected");
                this.dropDownTourName = item.tourName;
                // selectTrigger.querySelector("span").textContent = item.tourName === "all" ? "All tournament" : item.tourName;
                selectTrigger.querySelector("span").textContent = item.tourName;
                selectTrigger.querySelector("span").id = item.tourId;
            } 
            innerCustomOptions.appendChild(customOption);
            
            customOption.addEventListener("click", (e) => {
                e.stopPropagation();
                if (!customOption.classList.contains("selected")) {
                    document.querySelectorAll(`.cricket-fixture-container`).forEach((element) => {
                        element.style.display = "block";
                    });
                    innerCustomOptions.querySelector(".custom-option.selected").classList.remove("selected");
                    customOption.classList.add("selected");
                    selectTrigger.querySelector("span").textContent = customOption.textContent;
                    selectTrigger.querySelector("span").id = customOption.id;
                    innerCustomOptions.classList.add("display-none");
                    logoImg.classList.remove("dropdownArrowExpand");

                    me.tourId = customOption.getAttribute('value');
                    me.currentPage = 0; 
                    me.dropDownTourName = customOption.textContent
                    this.renderFallbackConcluded = false;  
                    this.elementStore = {};             
                    me.fixtureService.fetchFixtureData(
                        me.sportId, me.tourId, me.fixtureStatus, me.currentPage, PRIVATE_EVENTS.FULL_PAGE_FIXTURE_UPDATE, this.jsonConfig, () => {this.handleDropDownClick(me.tourId, me.sportId, me.fixtureStatus, this.tourMetaData)}
                    );
                    me.soccerMatchCardContainer.innerHTML = '';
                    me.eventManager.broadcastPublicEvent("FIXTURES_DROPDOWN_EVENT", {filterType:"Tournament", filterValue: customOption.textContent});
                    
                }
            });
        });

        const customoOptionMob = document.createElement("div");
        customoOptionMob.setAttribute("class", "custom-option-mob");
        dropDownArray?.forEach((item, index) => {
            // if (item.tourId != this.tourId) {
                let me = this;
                const customoOptionMobText = document.createElement("span");
                customoOptionMobText.setAttribute("class", "custom-option-mob-text");
                customoOptionMobText.setAttribute("value", item.tourId);
                customoOptionMobText.setAttribute("id", `dropdown${index}`);
                customoOptionMobText.innerText = item.tourName;
                const seprator = document.createElement('div');
                seprator.setAttribute('class', 'seprator');
                if(item.tourName != 'undefined' &&  item.tourName != undefined){
                    customoOptionMob.appendChild(customoOptionMobText)
                    if(index !== dropDownArray?.length - 1){
                        customoOptionMob.appendChild(seprator)
                    }
                }
                innerCustomOptionsMob.appendChild(customoOptionMob)

                customoOptionMobText.addEventListener("click", (e) => {
                    // e.stopPropagation();
                    if (!customoOptionMobText.classList.contains("selected")) {
                        document.querySelectorAll(`.cricket-fixture-container`).forEach((element) => {
                            element.style.display = "block";
                        });
                        innerCustomOptionsMob.querySelector(".custom-option-mob-text.selected")?.classList.remove("selected");
                        customoOptionMobText.classList.add("selected");
                        selectTrigger.querySelector("span").textContent = customoOptionMobText.textContent;
                        selectTrigger.querySelector("span").id = customoOptionMobText.id;
                        innerCustomOptions.classList.add("display-none");
                        logoImg.classList.remove("dropdownArrowExpand");

                        me.tourId = customoOptionMobText.getAttribute('value');
                        me.currentPage = 0;   
                        this.elementStore = {};
                        me.fixtureService.fetchFixtureData(
                            me.sportId, me.tourId, me.fixtureStatus, me.currentPage, PRIVATE_EVENTS.FULL_PAGE_FIXTURE_UPDATE, this.jsonConfig, () => {this.handleDropDownClick(me.tourId, me.sportId, me.fixtureStatus, this.tourMetaData)}
                        );
                        me.soccerMatchCardContainer.innerHTML = '';
                        me.eventManager.broadcastPublicEvent("FIXTURES_DROPDOWN_EVENT", {filterType:"Tournament", filterValue: customoOptionMob.textContent});
                        
                    }
                });
            // }
        });

        window.addEventListener('click', () => {
            if(document.getElementsByClassName("inner-custom-options").length > 0) {
                let innerCustomOptions = document.getElementsByClassName("inner-custom-options")[0]
                innerCustomOptions.classList.add("display-none");
            }
            if(document.getElementsByClassName("mob-option").length) {
                let innerCustomOptions = document.getElementsByClassName("mob-option")[0]
                innerCustomOptions.classList.add("display-none");
            }
            if (document.getElementsByClassName("dropdownArrowExpand").length > 0) {
                let dropDownExpand = document.getElementsByClassName("dropdownArrowExpand")[0]
                if(dropDownExpand) {
                    dropDownExpand.classList.remove("dropdownArrowExpand");
                }
            }
            const overlay = document.getElementsByClassName('overlay')[0]
            if (overlay) {
                overlay.classList.add("display-none");
                document.body.style.overflow = 'auto'; // Restore body scroll
            }
        });

        tournmentSelectWrapper.appendChild(selectDiv);
        soccerTopLevelCont.appendChild(tournmentSelectWrapper);
    }

    renderFullFixtureTeamDetails(teamType, teamName, teamRun, image, match) {
        const logoImg = new Image();
        logoImg.src = image;
        logoImg.onerror = function (e) {
            logoImg.src = `${ASSETS_IMAGES_BASE_URL}/counrty_flag_logo_fallback_image.svg`
        }
        logoImg.alt = teamName;
        const classList = `team-info-wrapper team-info-wrapper--${teamType}`;
        let wrapper = document.createElement('a');
        wrapper.setAttribute('class', classList);
        let teamMetaData = match?.teama_metadata;
        if(teamType === "away") {
            teamMetaData = match?.teamb_metadata;
        }        
        this.handleCTAClick("SET_HREF", teamMetaData, (route, isHrefEnabled) => {
            wrapper.href = route
            if(isHrefEnabled === false) {
                wrapper.classList.add("disablePointer")
            }
        });
        const teamLabel = document.createElement('div');
        teamLabel.setAttribute('class', 'team-name-label');
        if(teamName?.includes("/")){
            teamName = teamName?.split("/")
            teamName = teamName[0] + " /" + "\n" + teamName[1]
        }
        teamName = 
        teamLabel.innerText = teamName;
        wrapper.appendChild(logoImg);
        wrapper.appendChild(teamLabel);
        return wrapper;
    }

    renderFullFixtureFootballCard(match, matchCardOuterWrapper) {
        const matchCardInnerWrapper = this.createElement(matchCardOuterWrapper, "all-sports-fixture-inner-container", "");
        const matchName = document.createElement('a');
        matchName.setAttribute('class', "all-sports-fixture-match-name");
        this.handleCTAClick("SET_HREF", this.tourMetaData, (route, isHrefEnabled) => {
            matchName.href = route
            if(isHrefEnabled === false) {
                matchName.classList.add("disablePointer")
            }
        });
        matchName.innerText = match.series_short_display_name || match.series_short_name;
        matchCardInnerWrapper.appendChild(matchName);
        // const matchName = this.createElement(matchCardInnerWrapper, "all-sports-fixture-match-name", "", match.series_short_name);

        const fixtureMatchStatus = this.createElement(matchCardInnerWrapper, "all-sports-fixture-match-status", "", match.stage || match.match_stage);

        const teamDetails = this.createElement(matchCardInnerWrapper, "all-sports-fixture-team-details", "");


        const fixtureHomeTeam = this.createElement(teamDetails, "all-sports-fixture-home-team", "");
        let imageEndPoint = this.jsonConfig?.imageEndPoint ? this.jsonConfig?.imageEndPoint : JSON_IMAGE_BASE_URL
        const homeLogoSrc = `${imageEndPoint}/${match.sport_id}/${match.teama_id}.png`

        const homeDetails = this.renderFullFixtureTeamDetails('home', match.teama_short, match.teama_score, homeLogoSrc,match);
        fixtureHomeTeam.appendChild(homeDetails);

        const scoreDetails = this.createElement(teamDetails, "all-sports-fixture-detail-cont", "");
        teamDetails.appendChild(scoreDetails);

        const teamHomeTimeLabel = this.createElement(scoreDetails, "all-sports-fixture-time-label", "");
        teamHomeTimeLabel.innerText = match.teama_score && match.teamb_score ? '' : `Match Starts at`;

        const teamHomeScore = this.createElement(scoreDetails, "all-sports-fixture-home-score", "");
        teamHomeScore.innerText = match.teama_score && match.teamb_score ? `${match.teama_score} : ${match.teamb_score}` : `${convertTime(match.matchtime_ist)}`;
        // teamHomeScore.innerText = `${this.tConvert(match.matchtime_ist)}`;

        if(match.teama_score && match.teamb_score && match?.is_complete == true) {
            const scoreTextCont = this.createElement(scoreDetails, "all-sports-fixture-score-text", "");
            scoreTextCont.innerText = match.match_status;
        }

        if(match.teama_score && match.teamb_score && match?.is_live == true && match?.minutes) {
            const scoreTextCont = this.createElement(scoreDetails, "all-sports-fixture-minutes", "");
            let additinalMinutes = "";
            if (match?.additional_minutes > 0) {
                additinalMinutes = `+${match.additional_minutes}'`;
            }
            scoreTextCont.innerText = `${match?.minutes}'${additinalMinutes}`;
        }

        const awayLogoSrc = `${imageEndPoint}/${match.sport_id}/${match.teamb_id}.png`

        const fixtureAwayTeam = this.createElement(teamDetails, "all-sports-fixture-away-team", "");
        const awayDetails = this.renderFullFixtureTeamDetails('away', match.teamb_short, match.teamb_score, awayLogoSrc,match);
        fixtureAwayTeam.appendChild(awayDetails);

        let reminderIds = typeof localStorage != "undefined" && localStorage.getItem("sports_reminders") ? JSON.parse(localStorage.getItem("sports_reminders")) : this.reminderIds;
        let reminderAddId = this.assetConfig?.reminderTourId;
        if(reminderAddId && !reminderIds.includes(reminderAddId)) {
        reminderIds.push(reminderAddId)
        }
        let isSetReminder = reminderIds?.filter((item) => { return item.includes(match.match_id)})
        if (match?.metaDatum?.objectSubtype == "HIGHLIGHTS" && match?.metaDatum?.contentId != 0) {
            const buttonClassList = `all-sports-fixture-button-cont all-sports-fixture-match-completed`;
            const fixtureButtonContainer = document.createElement('a');
            fixtureButtonContainer.setAttribute('class', buttonClassList);
            fixtureButtonContainer.href = "javascript:void(0);";
            matchCardInnerWrapper.appendChild(fixtureButtonContainer)
            const logoImg = new Image();
            logoImg.src = playImage;
            fixtureButtonContainer.appendChild(logoImg);
            const fixtureButtonText = this.createElement(fixtureButtonContainer, "all-sports-fixture-button-text", "", "Watch Highlights");
            fixtureButtonContainer.addEventListener("click", (e) => {
                e.stopPropagation();
                this.handleCTAClick("WATCH_HIGHLIGHTS_EVENTS", match)
            })
        } else if (!match?.metaDatum?.objectSubtype && (match?.match_status_id == "9" || match?.event_status_id == "9") && (match?.match_id!= 0 || match?.metaDatum?.contentId != 0) && match?.releaseStartDate != 0 && match?.releaseStartDate > Date.now()) {
            const buttonsContainer = document.createElement('div');
            buttonsContainer.setAttribute('class', 'fixture_btn_container');
            matchCardInnerWrapper.appendChild(buttonsContainer);
            const fixtureButtonContainer = document.createElement('a');
            fixtureButtonContainer.setAttribute('class', 'fixture-button-cont fixture-match-completed');
            fixtureButtonContainer.href = "javascript:void(0);";
            const ActionImg = new Image();
            ActionImg.src = playImage
            fixtureButtonContainer.appendChild(ActionImg);
            const fixtureButtonText = document.createElement('div');
            fixtureButtonText.setAttribute('class', 'fixture-button-text');
            fixtureButtonText.textContent = 'Watch Preview';
            fixtureButtonContainer.appendChild(fixtureButtonText);
            fixtureButtonContainer.addEventListener('click', (e) => {
                e.stopPropagation();
                this.handleCTAClick('WATCH_PREVIEW_EVENTS', match);
            });

            if(match?.metaDatum?.contentId != 0){
                buttonsContainer.appendChild(fixtureButtonContainer);
            }

            const fixtureNotificationContainer = document.createElement('a');
            fixtureNotificationContainer.setAttribute('class', 'fixture-button-notification fixture-match-completed');
            fixtureNotificationContainer.href = "javascript:void(0);";
            const NotificationImg = new Image();
            NotificationImg.src = notifyImage

            const fixtureNotificationText = document.createElement('span');
            fixtureNotificationText.setAttribute('class', 'fixture-notification-text');
            fixtureNotificationText.innerHTML = 'Set Reminder'
            fixtureNotificationContainer.appendChild(NotificationImg);
            fixtureNotificationContainer.appendChild(fixtureNotificationText);

            if(isSetReminder?.length > 0) {
                fixtureNotificationContainer.classList.add("disabled")
                NotificationImg.src = tickImage;
                fixtureNotificationText.innerHTML = "Reminder Set";
            }
            fixtureNotificationContainer.addEventListener("click",(e) => {
                if(!e.currentTarget.classList.contains("disabled")) {
                e.stopPropagation();
                this.handleCTAClick("SET_REMINDER_EVENTS",match,(setReminderStatus) => {
                    if(setReminderStatus == true) {
                        fixtureNotificationContainer.classList.add("disabled")
                        NotificationImg.src = tickImage;
                        fixtureNotificationText.innerHTML = "Reminder Set";
                    }
                });
                }
            });
            buttonsContainer.appendChild(fixtureNotificationContainer);
        } else if (match?.metaDatum?.objectSubtype == "LIVE_SPORT" && match?.metaDatum?.contentId != 0) {
            // const fixtureButtonContainer = this.createElement(matchCardInnerWrapper, "all-sports-fixture-button-cont all-sports-fixture-match-live", "");
            const buttonClassList = `all-sports-fixture-button-cont all-sports-fixture-match-live`;
            const fixtureButtonContainer = document.createElement('a');
            fixtureButtonContainer.setAttribute('class', buttonClassList);
            fixtureButtonContainer.href = "javascript:void(0);";
            const liveIcon = document.createElement('div');
            liveIcon.setAttribute('class', 'live-circle')
            fixtureButtonContainer.appendChild(liveIcon);
            matchCardInnerWrapper.appendChild(fixtureButtonContainer)
            const fixtureButtonText = this.createElement(fixtureButtonContainer, "all-sports-fixture-button-text", "", "Watch Live");
            if(match?.metaDatum?.contractStartDate != 0 && match?.metaDatum?.contractStartDate > Date.now()){
                fixtureButtonContainer.style.display = 'none'
                let delta = match?.metaDatum?.contractStartDate - Date.now()
                setTimeout(()=> {
                    fixtureButtonContainer.style.display = 'flex'
                },delta)
            }
            fixtureButtonContainer.addEventListener("click", (e) => {
                e.stopPropagation();
                this.handleCTAClick("WATCH_LIVE_EVENTS", match)
            })
        }
        if(typeof this.widgetCallback == "function"){
            this.widgetCallback("FIXTURE_MULTI_RENDER_SUCCESS", this.tourName,this.tourMetaData)
        }
    }
    
    renderFullFixtureCricketCard(match, matchCardOuterWrapper) {
        const matchCardInnerWrapper = this.createElement(matchCardOuterWrapper, "all-sports-fixture-inner-container", "");
        const matchName = document.createElement('a');
        matchName.setAttribute('class', "cricket-fixture-match-name");
        this.handleCTAClick("SET_HREF", this.tourMetaData, (route, isHrefEnabled) => {
            matchName.href = route
            if(isHrefEnabled === false) {
                matchName.classList.add("disablePointer")
            }
        });
        matchName.innerText = match?.tour_name;
        matchCardInnerWrapper.appendChild(matchName);
        // const matchName = this.createElement(matchCardInnerWrapper, "cricket-fixture-match-name", "", match.series_short_name);

        const firstUpIndex = match?.participants?.findIndex(item => item?.firstup === "true");
        // If found, move it to the first index
        if (firstUpIndex !== -1) {
            const firstUpItem = match?.participants?.splice(firstUpIndex, 1)[0];
            match?.participants?.unshift(firstUpItem);
        }
        
        const fixtureMatchStatus = this.createElement(matchCardInnerWrapper, "cricket-fixture-match-status", "", match?.event_stage);
        const teamDetails = this.createElement(matchCardInnerWrapper, "cricket-fixture-team-details", "");
        const fixtureHomeTeam = this.createElement(teamDetails, "cricket-fixture-teams", "");
        let imageEndPoint = this.jsonConfig?.imageEndPoint ? this.jsonConfig?.imageEndPoint : JSON_IMAGE_BASE_URL
        let homeLogoSrc = `${imageEndPoint}/${match.sport_id}/${match?.participants[0].id}.png`
        const homeDetails = this.renderFullFixtureTeamDetails('home', match?.participants[0].short_name, match?.participants[0].id, homeLogoSrc,match);
        fixtureHomeTeam.appendChild(homeDetails);

        const scoreDetails = this.createElement(teamDetails, "cricket-fixture-detail-cont", "");
        teamDetails.appendChild(scoreDetails);

        const teamHomeTimeLabel = this.createElement(scoreDetails, "cricket-fixture-time-label", "");
        const teamHomeScore = this.createElement(scoreDetails, "cricket-fixture-home-score", "");

        if(match.participants && !(match?.event_status_id == 115)){
            const teamAScoresValue = match?.participants[0].value?.split('&')
            const teamBScoresValue = match?.participants[1].value?.split('&')

            const teamAScore = document.createElement('div');
            teamAScore.setAttribute('class', 'fixture-teamA-score');
            teamHomeScore.appendChild(teamAScore);
      
            const teamBScore = document.createElement('div');
            teamBScore.classList.add('fixture-teamB-score');
            teamHomeScore.appendChild(teamBScore);

            const teamAScoreSecond = document.createElement('div');
            teamAScoreSecond.setAttribute('class', 'fixture-teamA-score');

            const teamBScoreSecond = document.createElement('div');
            teamBScoreSecond.classList.add('fixture-teamB-score');

            if((teamAScoresValue && teamAScoresValue[1]) || (teamBScoresValue && teamBScoresValue[1])){
                teamHomeScore.appendChild(teamAScoreSecond);
                teamHomeScore.appendChild(teamBScoreSecond);
            }
      
            const teamAOvers = document.createElement('div');
            teamAOvers.setAttribute('class', 'fixture-teamA-overs');
            teamHomeScore.appendChild(teamAOvers);
      
            const teamBOvers = document.createElement('div');
            teamBOvers.setAttribute('class', 'fixture-teamB-overs');
            teamHomeScore.appendChild(teamBOvers);

            if(teamAScoresValue && teamAScoresValue[0]){
                const [runs, overs] = teamAScoresValue[0].includes('dec') ? teamAScoresValue[0].split('dec ') : teamAScoresValue[0].split(' ');
                teamAScore.innerText = runs;
                teamAOvers.innerText = `${overs.replace(/[()]/g, '')} Overs`
            }
        
            if(teamBScoresValue && teamBScoresValue[0]){
                const [runs, overs] = teamBScoresValue[0].includes('dec') ? teamBScoresValue[0].split('dec ') : teamBScoresValue[0].split(' ');
                teamBScore.innerText = runs;
                teamBOvers.innerText = `${overs.replace(/[()]/g, '')} Overs`
            }

            if(teamAScoresValue && teamAScoresValue[1]){
                const [runs, overs] = teamAScoresValue[1].includes('dec') ? teamAScoresValue[1].trim().split('dec ') : teamAScoresValue[1].trim().split(' ');
                teamAScoreSecond.innerText = runs;
                teamAOvers.innerText = `${overs.replace(/[()]/g, '')} Overs`
            }
        
            if(teamBScoresValue && teamBScoresValue[1]){
                const [runs, overs] = teamBScoresValue[1].includes('dec') ? teamBScoresValue[1].trim().split('dec ') : teamBScoresValue[1].trim().split(' ');
                teamBScoreSecond.innerText = runs;
                teamBOvers.innerText = `${overs.replace(/[()]/g, '')} Overs`
            }

          } else {
            teamHomeTimeLabel.innerText =  `Match Starts at`;
            teamHomeScore.innerText =
             `${convertTime(new Date(match?.start_date).toLocaleTimeString([], {hour: '2-digit', minute: '2-digit'}))}`;
          }

        const awayLogoSrc = `${imageEndPoint}/${match.sport_id}/${match?.participants[1].id}.png`
        const fixtureAwayTeam = this.createElement(teamDetails, "cricket-fixture-teams", "");
        const awayDetails = this.renderFullFixtureTeamDetails('away', match?.participants[1].short_name, match?.participants[1].id, awayLogoSrc,match);
        fixtureAwayTeam.appendChild(awayDetails);

        let reminderIds = typeof localStorage != "undefined" && localStorage.getItem("sports_reminders") ? JSON.parse(localStorage.getItem("sports_reminders")) : this.reminderIds;
        let reminderAddId = this.assetConfig?.reminderTourId;
        if(reminderAddId && !reminderIds.includes(reminderAddId)) {
        reminderIds.push(reminderAddId)
        }
        let isSetReminder = reminderIds?.filter((item) => { return item.includes(match.match_id)})
        if ((match?.metaDatum?.objectSubtype == "HIGHLIGHTS" && match?.metaDatum?.contentId != 0) || (match.teama_score && match.teamb_score)) {
            // const fixtureButtonContainer = this.createElement(matchCardInnerWrapper, "cricket-fixture-button-cont cricket-fixture-match-completed", "");
            const buttonClassList = `cricket-fixture-button-cont cricket-fixture-match-completed`;
            const fixtureButtonContainer = document.createElement('a');
            fixtureButtonContainer.setAttribute('class', buttonClassList);
            fixtureButtonContainer.href = "javascript:void(0);";
            matchCardInnerWrapper.appendChild(fixtureButtonContainer)
            const logoImg = new Image();
            logoImg.src = playImage;
            fixtureButtonContainer.appendChild(logoImg);
            const fixtureButtonText = this.createElement(fixtureButtonContainer, "cricket-fixture-button-text", "", "Watch Highlights");
            fixtureButtonContainer.addEventListener("click", (e) => {
                e.stopPropagation();
                this.handleCTAClick("WATCH_HIGHLIGHTS_EVENTS", match)
            })
        } else if (!match?.metaDatum?.objectSubtype && (match?.match_status_id == "115" || match?.event_status_id == "115") && (match?.match_id!= 0 || match?.metaDatum?.contentId != 0) && match?.releaseStartDate != 0 && match?.releaseStartDate > Date.now()) {
            const buttonsContainer = document.createElement('div');
            buttonsContainer.setAttribute('class', 'fixture_btn_container');
            matchCardInnerWrapper.appendChild(buttonsContainer);
            const fixtureButtonContainer = document.createElement('a');
            fixtureButtonContainer.setAttribute('class', 'fixture-button-cont fixture-match-completed');
            fixtureButtonContainer.href = "javascript:void(0);";
            const ActionImg = new Image();
            ActionImg.src = playImage
            fixtureButtonContainer.appendChild(ActionImg);
            const fixtureButtonText = document.createElement('div');
            fixtureButtonText.setAttribute('class', 'fixture-button-text');
            fixtureButtonText.textContent = 'Watch Preview';
            fixtureButtonContainer.appendChild(fixtureButtonText);
            fixtureButtonContainer.addEventListener('click', (e) => {
                e.stopPropagation();
                this.handleCTAClick('WATCH_PREVIEW_EVENTS', match);
            });

            if(match?.metaDatum?.contentId != 0){
                buttonsContainer.appendChild(fixtureButtonContainer);
            }

            const fixtureNotificationContainer = document.createElement('a');
            fixtureNotificationContainer.setAttribute('class', 'fixture-button-notification fixture-match-completed');
            fixtureNotificationContainer.href = "javascript:void(0);";
            const NotificationImg = new Image();
            NotificationImg.src = notifyImage

            const fixtureNotificationText = document.createElement('span');
            fixtureNotificationText.setAttribute('class', 'fixture-notification-text');
            fixtureNotificationText.innerHTML = 'Set Reminder'
            fixtureNotificationContainer.appendChild(NotificationImg);
            fixtureNotificationContainer.appendChild(fixtureNotificationText);

            if(isSetReminder?.length > 0) {
                fixtureNotificationContainer.classList.add("disabled")
                NotificationImg.src = tickImage;
                fixtureNotificationText.innerHTML = "Reminder Set";
            }
            fixtureNotificationContainer.addEventListener("click",(e) => {
                if(!e.currentTarget.classList.contains("disabled")) {
                e.stopPropagation();
                this.handleCTAClick("SET_REMINDER_EVENTS",match,(setReminderStatus) => {
                    if(setReminderStatus == true) {
                        fixtureNotificationContainer.classList.add("disabled")
                        NotificationImg.src = tickImage;
                        fixtureNotificationText.innerHTML = "Reminder Set";
                    }
                });
                }
            });
            buttonsContainer.appendChild(fixtureNotificationContainer);
        } else if (match?.metaDatum?.objectSubtype == "LIVE_SPORT" && match?.metaDatum?.contentId != 0) {
            // const fixtureButtonContainer = this.createElement(matchCardInnerWrapper, "cricket-fixture-button-cont cricket-fixture-match-live", "");
            const buttonClassList = `cricket-fixture-button-cont cricket-fixture-match-live`;
            const fixtureButtonContainer = document.createElement('a');
            fixtureButtonContainer.setAttribute('class', buttonClassList);
            fixtureButtonContainer.href = "javascript:void(0);";
            const liveIcon = document.createElement('div');
            liveIcon.setAttribute('class', 'live-circle')
            fixtureButtonContainer.appendChild(liveIcon);
            matchCardInnerWrapper.appendChild(fixtureButtonContainer)
            const fixtureButtonText = this.createElement(fixtureButtonContainer, "cricket-fixture-button-text", "", "Watch Live");
            if(match?.metaDatum?.contractStartDate != 0 && match?.metaDatum?.contractStartDate > Date.now()){
                fixtureButtonContainer.style.display = 'none'
                let delta = match?.metaDatum?.contractStartDate - Date.now()
                setTimeout(()=> {
                    fixtureButtonContainer.style.display = 'flex'
                },delta)
            }
            fixtureButtonContainer.addEventListener("click", (e) => {
                e.stopPropagation();
                this.handleCTAClick("WATCH_LIVE_EVENTS", match)
            })
        }
        if(typeof this.widgetCallback == "function"){
            this.widgetCallback("FIXTURE_MULTI_RENDER_SUCCESS", this.tourName,this.tourMetaData)
        }
    }

    renderFullFixtureTennisCard(match, matchCardOuterWrapper) {
        const matchCardInnerWrapper = this.createElement(matchCardOuterWrapper, "all-sports-fixture-inner-container", "");
        
        if(!match?.upcoming){
            let teamANames = match?.teama.includes("/") ? match?.teama.split("/") : [match?.teama];
            let teamBNames = match?.teamb.includes("/") ? match?.teamb.split("/") : [match?.teamb];
            matchCardInnerWrapper.innerHTML = 
            `<div class="all-sports-fixture-inner-container"><a class="all-sports-fixture-match-name">${match?.tourname} | ${match.comp_type}</a>
                <div class="all-sports-fixture-match-status"></div>
                <div class="team_a_main_container">
                    <div class="team_a_player_container"><img src="${SI_IMAGE_URL_TENNIS}${match?.teama_info[0]?.country_id}.png" onerror="this.src='${ASSETS_IMAGES_BASE_URL}/counrty_flag_logo_fallback_image.svg'" alt="NLD" height="16"
                            width="16">
                        <div class="team-name-label">${convertName(match?.teama_info[0]?.name || teamANames[0])}</div>
                        ${match?.teama_info?.length > 1 || teamANames.length > 1 ? 
                            `<div class="team-name-slashSpan"> / </div><img src="${SI_IMAGE_URL_TENNIS}${match?.teama_info[1]?.country_id || ""}.png" onerror="this.src='${ASSETS_IMAGES_BASE_URL}/counrty_flag_logo_fallback_image.svg'"  alt="ESP" height="16"
                            width="16">
                            <div class="team-name-label">${convertName(match?.teama_info[1]?.name || teamANames[1])}</div>` : ''}
                    </div>
                    <div class="team_a_score_container">${this.renderTennisScoreDetails(match?.teama_id, match?.sets)}</div>
                </div>
                <div class="seprator"></div>
                <div class="team_b_main_container">
                    <div class="team_b_player_container"><img src="${SI_IMAGE_URL_TENNIS}${match?.teamb_info[0]?.country_id}.png" onerror="this.src='${ASSETS_IMAGES_BASE_URL}/counrty_flag_logo_fallback_image.svg'" alt="NLD" height="16"
                            width="16">
                        <div class="team-name-label">${convertName(match?.teamb_info[0]?.name || teamBNames[0])}</div>
                        ${match?.teamb_info?.length > 1 || teamBNames.length > 1?
                            `<div class="team-name-slashSpan"> / </div><img src="${SI_IMAGE_URL_TENNIS}${match?.teamb_info[1]?.country_id || ""}.png" onerror="this.src='${ASSETS_IMAGES_BASE_URL}/counrty_flag_logo_fallback_image.svg'" alt="ESP" height="16"
                                width="16">
                            <div class="team-name-label">${convertName(match?.teamb_info[1]?.name || teamBNames[1])}</div>` : ''}
                    </div>
                    <div class="team_b_score_container">${this.renderTennisScoreDetails(match?.teamb_id, match?.sets)}</div>
                </div>
            </div>`
        } else {
            this.isDoublesMatch = (match?.teama_info?.length > 1) || false;
            let imageEndPoint = this.jsonConfig?.imageEndPoint ? this.jsonConfig?.imageEndPoint : JSON_IMAGE_BASE_URL;

            const allSportsInnerContainer = document.createElement('div');
            allSportsInnerContainer.setAttribute('class', 'all-sports-fixture-inner-container');

            const fixtureMatchName = document.createElement('a');
            fixtureMatchName.setAttribute('class', 'all-sports-fixture-match-name');
            fixtureMatchName.innerText = match?.tourname + " | " + match?.comp_type;
            allSportsInnerContainer.appendChild(fixtureMatchName);

            const fixtureMatchStatus = document.createElement('div');
            fixtureMatchStatus.setAttribute('class', 'all-sports-fixture-match-status');
            fixtureMatchStatus.innerText = match?.matchstage || 'Quarter Final';
            allSportsInnerContainer.appendChild(fixtureMatchStatus);

            matchCardInnerWrapper.appendChild(allSportsInnerContainer);
            if(this.isDoublesMatch){
                // const fixtureMatchTime = document.createElement('div');
                // fixtureMatchTime.setAttribute('class', 'doubles-fixture-match-time');
                // fixtureMatchTime.innerText = convertTime(match?.matchtime_ist);
                // matchCardInnerWrapper.appendChild(fixtureMatchTime);
        
                const doublesFixtureContainer = document.createElement('div');
                doublesFixtureContainer.setAttribute('class', 'doubles-fixture-container');
        
                const teamA = document.createElement('div');
                teamA.setAttribute('class', 'doubles-fixture-team-wrapper');
        
                const teamAPlayerAWrapper = document.createElement('div');
                teamAPlayerAWrapper.setAttribute('class', 'doubles-fixture-team-player-wrapper');
        
                const teamAPlayerALogo = new Image();
                // teamAPlayerALogo.src = `${imageEndPoint}/${this.sportId}/${match?.teama_info[0]?.country_id}.png`;
                teamAPlayerALogo.src = `${SI_IMAGE_URL_TENNIS}${match?.teama_info[0]?.country_id}.png`;
                teamAPlayerALogo.onerror = function (e) {
                  teamAPlayerALogo.src = `${ASSETS_IMAGES_BASE_URL}/counrty_flag_logo_fallback_image.svg`;
                }
        
                const teamAPlayerALabel = document.createElement('div');
                teamAPlayerALabel.setAttribute('class', 'doubles-fixture-team-label');
                teamAPlayerALabel.innerText = convertName(match?.teama_info[0]?.name);
        
                teamAPlayerAWrapper.appendChild(teamAPlayerALogo);
                teamAPlayerAWrapper.appendChild(teamAPlayerALabel);
        
                teamA.appendChild(teamAPlayerAWrapper);
        
                const teamAPlayerBWrapper = document.createElement('div');
                teamAPlayerBWrapper.setAttribute('class', 'doubles-fixture-team-player-wrapper');
        
                const teamAPlayerBLogo = new Image();
                // teamAPlayerBLogo.src = `${imageEndPoint}/${this.sportId}/${match?.teama_info[1]?.country_id}.png`;
                teamAPlayerBLogo.src = `${SI_IMAGE_URL_TENNIS}${match?.teama_info[1]?.country_id}.png`;
                teamAPlayerBLogo.onerror = function (e) {
                  teamAPlayerBLogo.src = `${ASSETS_IMAGES_BASE_URL}/counrty_flag_logo_fallback_image.svg`;
                }
        
                const teamAPlayerBLabel = document.createElement('div');
                teamAPlayerBLabel.setAttribute('class', 'doubles-fixture-team-label');
                teamAPlayerBLabel.innerText = convertName(match?.teama_info[1]?.name);
        
                teamAPlayerBWrapper.appendChild(teamAPlayerBLogo);
                teamAPlayerBWrapper.appendChild(teamAPlayerBLabel);
        
                teamA.appendChild(teamAPlayerBWrapper);
        
                const versusContainer = document.createElement('div');
                versusContainer.setAttribute('class', 'doubles-versus-container')
                versusContainer.innerText = convertTime(match?.matchtime_ist);
        
                const teamB = document.createElement('div');
                teamB.setAttribute('class', 'doubles-fixture-team-wrapper');
        
                const teamBPlayerAWrapper = document.createElement('div');
                teamBPlayerAWrapper.setAttribute('class', 'doubles-fixture-team-player-wrapper');
                teamBPlayerAWrapper.classList.add("doubles-player-team-b");
        
                const teamBPlayerALogo = new Image();
                // teamBPlayerALogo.src = `${imageEndPoint}/${this.sportId}/${match?.teamb_info[0]?.country_id}.png`;
                teamBPlayerALogo.src = `${SI_IMAGE_URL_TENNIS}${match?.teamb_info[0]?.country_id}.png`;
                teamBPlayerALogo.onerror = function (e) {
                  teamBPlayerALogo.src = `${ASSETS_IMAGES_BASE_URL}/counrty_flag_logo_fallback_image.svg`;
                }
        
                const teamBPlayerALabel = document.createElement('div');
                teamBPlayerALabel.setAttribute('class', 'doubles-fixture-team-label');
                teamBPlayerALabel.innerText = convertName(match?.teamb_info[0]?.name);
        
                teamBPlayerAWrapper.appendChild(teamBPlayerALabel);
                teamBPlayerAWrapper.appendChild(teamBPlayerALogo);
        
                teamB.appendChild(teamBPlayerAWrapper);
        
                const teamBPlayerBWrapper = document.createElement('div');
                teamBPlayerBWrapper.setAttribute('class', 'doubles-fixture-team-player-wrapper');
                teamBPlayerBWrapper.classList.add("doubles-player-team-b");
        
                const teamBPlayerBLogo = new Image();
                // teamBPlayerBLogo.src = `${imageEndPoint}/${this.sportId}/${match?.teamb_info[1]?.country_id}.png`;
                teamBPlayerBLogo.src = `${SI_IMAGE_URL_TENNIS}${match?.teamb_info[1]?.country_id}}.png`;
                teamBPlayerBLogo.onerror = function (e) {
                  teamBPlayerBLogo.src = `${ASSETS_IMAGES_BASE_URL}/counrty_flag_logo_fallback_image.svg`;
                }
        
                const teamBPlayerBLabel = document.createElement('div');
                teamBPlayerBLabel.setAttribute('class', 'doubles-fixture-team-label');
                teamBPlayerBLabel.innerText = convertName(match?.teamb_info[1]?.name);
        
                teamBPlayerBWrapper.appendChild(teamBPlayerBLabel);
                teamBPlayerBWrapper.appendChild(teamBPlayerBLogo);
        
                teamB.appendChild(teamBPlayerBWrapper);
        
                doublesFixtureContainer.appendChild(teamA);
                doublesFixtureContainer.appendChild(versusContainer);
                doublesFixtureContainer.appendChild(teamB);
        
                matchCardInnerWrapper.appendChild(doublesFixtureContainer);
        
              } else {
                const singlesFixtureContainer = document.createElement('div');
                singlesFixtureContainer.setAttribute('class', 'singles-fixture-container');
        
                const teamA = document.createElement('div');
                teamA.setAttribute('class', 'singles-fixture-team-wrapper');
                const teamALogo = new Image();
                // teamALogo.src = `${imageEndPoint}/${this.sportId}/${match?.teama_info[0]?.country_id}.png`;
                teamALogo.src = `${SI_IMAGE_URL_TENNIS}${match?.teama_info[0]?.country_id}.png`;
                teamALogo.onerror = function (e) {
                  teamALogo.src = `${ASSETS_IMAGES_BASE_URL}/counrty_flag_logo_fallback_image.svg`;
                }
                const teamALabel = document.createElement('div');
                teamALabel.setAttribute('class', 'singles-fixture-team-label');
                teamALabel.innerText = convertName(match?.teama);
        
                teamA.appendChild(teamALogo);
                teamA.appendChild(teamALabel);

                const singlesFixtureTimeContainer = document.createElement('div');
                singlesFixtureTimeContainer.setAttribute('class', 'singles-fixture-time-conatiner');
                singlesFixtureTimeContainer.innerText = convertTime(match?.matchtime_ist);
        
                const teamB = document.createElement('div');
                teamB.setAttribute('class', 'singles-fixture-team-wrapper');
                const teamBLogo = new Image();
                // teamBLogo.src = `${imageEndPoint}/${this.sportId}/${match?.teamb_info[0]?.country_id}.png`;
                teamBLogo.src = `${SI_IMAGE_URL_TENNIS}${match?.teamb_info[0]?.country_id}.png`;

                teamBLogo.onerror = function (e) {
                  teamBLogo.src = `${ASSETS_IMAGES_BASE_URL}/counrty_flag_logo_fallback_image.svg`;
                }
                const teamBLabel = document.createElement('div');
                teamBLabel.setAttribute('class', 'singles-fixture-team-label');
                teamBLabel.innerText = convertName(match?.teamb);
        
                teamB.appendChild(teamBLogo);
                teamB.appendChild(teamBLabel);
        
                singlesFixtureContainer.appendChild(teamA)
                singlesFixtureContainer.appendChild(singlesFixtureTimeContainer);
                singlesFixtureContainer.appendChild(teamB)
        
                const singlesFixtureWrapper = document.createElement('div');
                singlesFixtureWrapper.setAttribute('class', 'singles-fixture-wrapper');
        
                singlesFixtureWrapper.appendChild(singlesFixtureContainer);
                matchCardInnerWrapper.appendChild(singlesFixtureWrapper);
              }
        }
        
        let reminderIds = typeof localStorage != "undefined" && localStorage.getItem("sports_reminders") ? JSON.parse(localStorage.getItem("sports_reminders")) : this.reminderIds;
        let reminderAddId = this.assetConfig?.reminderTourId;
        if(reminderAddId && !reminderIds.includes(reminderAddId)) {
        reminderIds.push(reminderAddId)
        }
        let isSetReminder = reminderIds?.filter((item) => { return item.includes(match.match_id)})
        if (match?.metaDatum?.objectSubtype == "HIGHLIGHTS" && match?.metaDatum?.contentId != 0) {
            // const fixtureButtonContainer = this.createElement(matchCardInnerWrapper, "all-sports-fixture-button-cont all-sports-fixture-match-completed", "");
            const buttonClassList = `all-sports-fixture-button-cont all-sports-fixture-match-completed`;
            const fixtureButtonContainer = document.createElement('a');
            fixtureButtonContainer.setAttribute('class', buttonClassList);
            fixtureButtonContainer.href = "javascript:void(0);";
            matchCardInnerWrapper.appendChild(fixtureButtonContainer)
            const logoImg = new Image();
            logoImg.src = playImage;
            fixtureButtonContainer.appendChild(logoImg);
            const fixtureButtonText = this.createElement(fixtureButtonContainer, "all-sports-fixture-button-text", "", "Watch Highlights");
            fixtureButtonContainer.addEventListener("click", (e) => {
                e.stopPropagation();
                this.handleCTAClick("WATCH_HIGHLIGHTS_EVENTS", match)
            })
        } else if (!match?.metaDatum?.objectSubtype && (match?.match_status_id == "12" || match?.matchstatus_id == "12") && (match?.match_id!= 0 || match?.metaDatum?.contentId != 0) && match?.releaseStartDate != 0 && match?.releaseStartDate > Date.now()) {
            const buttonsContainer = document.createElement('div');
            buttonsContainer.setAttribute('class', 'fixture_btn_container');
            matchCardInnerWrapper.appendChild(buttonsContainer);
            const fixtureButtonContainer = document.createElement('a');
            fixtureButtonContainer.setAttribute('class', 'fixture-button-cont fixture-match-completed');
            fixtureButtonContainer.href = "javascript:void(0);";
            const ActionImg = new Image();
            ActionImg.src = playImage
            fixtureButtonContainer.appendChild(ActionImg);
            const fixtureButtonText = document.createElement('div');
            fixtureButtonText.setAttribute('class', 'fixture-button-text');
            fixtureButtonText.textContent = 'Watch Preview';
            fixtureButtonContainer.appendChild(fixtureButtonText);
            fixtureButtonContainer.addEventListener('click', (e) => {
                e.stopPropagation();
                this.handleCTAClick('WATCH_PREVIEW_EVENTS', match);
            });

            if(match?.metaDatum?.contentId != 0){
                buttonsContainer.appendChild(fixtureButtonContainer);
            }

            const fixtureNotificationContainer = document.createElement('a');
            fixtureNotificationContainer.setAttribute('class', 'fixture-button-notification fixture-match-completed');
            fixtureNotificationContainer.href = "javascript:void(0);";
            const NotificationImg = new Image();
            NotificationImg.src = notifyImage

            const fixtureNotificationText = document.createElement('span');
            fixtureNotificationText.setAttribute('class', 'fixture-notification-text');
            fixtureNotificationText.innerHTML = 'Set Reminder'
            fixtureNotificationContainer.appendChild(NotificationImg);
            fixtureNotificationContainer.appendChild(fixtureNotificationText);

            if(isSetReminder?.length > 0) {
                fixtureNotificationContainer.classList.add("disabled")
                NotificationImg.src = tickImage;
                fixtureNotificationText.innerHTML = "Reminder Set";
            }
            fixtureNotificationContainer.addEventListener("click",(e) => {
                if(!e.currentTarget.classList.contains("disabled")) {
                e.stopPropagation();
                this.handleCTAClick("SET_REMINDER_EVENTS",match,(setReminderStatus) => {
                    if(setReminderStatus == true) {
                        fixtureNotificationContainer.classList.add("disabled")
                        NotificationImg.src = tickImage;
                        fixtureNotificationText.innerHTML = "Reminder Set";
                    }
                });
                }
            });
            buttonsContainer.appendChild(fixtureNotificationContainer);
        } else if (match?.metaDatum?.objectSubtype == "LIVE_SPORT" && match?.metaDatum?.contentId != 0) {
            const buttonClassList = `all-sports-fixture-button-cont all-sports-fixture-match-live`;
            const fixtureButtonContainer = document.createElement('a');
            fixtureButtonContainer.setAttribute('class', buttonClassList);
            fixtureButtonContainer.href = "javascript:void(0);";
            const liveIcon = document.createElement('div');
            liveIcon.setAttribute('class', 'live-circle')
            fixtureButtonContainer.appendChild(liveIcon);
            matchCardInnerWrapper.appendChild(fixtureButtonContainer)
            const fixtureButtonText = this.createElement(fixtureButtonContainer, "all-sports-fixture-button-text", "", "Watch Live");
            if(match?.metaDatum?.contractStartDate != 0 && match?.metaDatum?.contractStartDate > Date.now()){
                fixtureButtonContainer.style.display = 'none'
                let delta = match?.metaDatum?.contractStartDate - Date.now()
                setTimeout(()=> {
                    fixtureButtonContainer.style.display = 'flex'
                },delta)
            }
            fixtureButtonContainer.addEventListener("click", (e) => {
                e.stopPropagation();
                this.handleCTAClick("WATCH_LIVE_EVENTS", match)
            })
        }
        if(typeof this.widgetCallback == "function"){
            this.widgetCallback("FIXTURE_MULTI_RENDER_SUCCESS", this.tourName,this.tourMetaData)
        }    
    }

    renderTennisScoreDetails(teamId, score){
        let teamScore = '';

        score.forEach(set => {
            const teamSetScore = set.set_score[teamId];
            const opponentSetScore = Object.values(set.set_score).find(score => score !== teamSetScore);

            const scoreClass = teamSetScore > opponentSetScore ? '' : 'blur';

            teamScore += `<span class="${scoreClass}">${teamSetScore}</span> `;
        });

        return teamScore.trim();
    }

    renderMatchCard(soccerMatchCardContainer, isFromConcluded) {
        if(this.fixtureData && this.fixtureData.length > 0) {
            let fixtureSortedData = new Map();
            this.fixtureData.forEach(fixtureValue => {
                let matchDate = fixtureValue?.sport_id == 3 ? fixtureValue?.tennis.matchdate_gmt : (fixtureValue?.sport_id == 2 ? fixtureValue?.football?.gmt_date : fixtureValue?.cricket?.start_date)
                matchDate = new Date(matchDate).toDateString();
                if (!fixtureSortedData.has(matchDate)) {
                    fixtureSortedData.set(matchDate, []);
                }

                let sport = fixtureValue?.sport_id == 3 ? "tennis" : (fixtureValue?.sport_id == 2 ? "football" : "cricket");
                fixtureValue[sport]["sport_id"] = fixtureValue?.sport_id;
                fixtureSortedData.get(matchDate).push(fixtureValue[sport]);
            });
    
            const sortedDates = Array.from(fixtureSortedData.keys()).sort((a, b) => {
                const date1 = new Date(a);
                const date2 = new Date(b);
                return isFromConcluded ? date2 - date1 : date1 - date2;
            });
    
            sortedDates.forEach(date => {
                const matchCards = fixtureSortedData.get(date).filter(matchCard => {
                    // if (isFromConcluded) {
                    //     return matchCard.is_complete == true;
                    // } else {
                    //     return matchCard.is_live == true || matchCard.is_upcoming == true ;
                    // }
                    return matchCard;
                });
                if (matchCards.length > 0) {
                    const soccerDateOuterContainer = this.elementStore[`date-match-${new Date(date).toLocaleDateString()}`] 
                                                        || this.createElement(soccerMatchCardContainer, "all-sports-date-match-outer-container", `date-match-${new Date(date).toLocaleDateString()}`, "");
                    const dateFormat = new Date(date).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
                    const formatedDate = `${dateFormat}`;
                    if(!this.elementStore[`date-${new Date(date).toLocaleDateString()}`]){
                        this.createElement(soccerDateOuterContainer, "all-sports-date-container", `date-${new Date(date).toLocaleDateString()}`, formatedDate);
                    }   
                    const soccerMatchOuterContainer = this.elementStore[`match-${new Date(date).toLocaleDateString()}`] || this.createElement(soccerDateOuterContainer, "all-sports-match-outer-container", `match-${new Date(date).toLocaleDateString()}`);
    
                    matchCards.forEach(matchCard => {
                        const matchCardWrapperClass = isFromConcluded ? "all-sports-fixture-container all-sports-fixture-Container-concluded" : "all-sports-fixture-container all-sports-fixture-Container-live";
                        const matchCardWrapper = document.createElement('a');
                        matchCardWrapper.setAttribute('class', matchCardWrapperClass);
                        this.handleCTAClick("SET_HREF", matchCard?.match_metadata, (route, isHrefEnabled) => {
                            matchCardWrapper.href = route
                            if(isHrefEnabled === false) {
                                matchCardWrapper.classList.add("disablePointer")
                            }
                        });
                        soccerMatchOuterContainer.appendChild(matchCardWrapper);

                        switch (matchCard?.sport_id) {
                            case 1:{
                                this.renderFullFixtureCricketCard(matchCard, matchCardWrapper);
                                break;
                            }
                            case 2:{
                                this.renderFullFixtureFootballCard(matchCard, matchCardWrapper);
                                break;
                            }
                            case 3:{
                                this.renderFullFixtureTennisCard(matchCard, matchCardWrapper);
                                break;
                            }
                            
                        }
                    });
                }
            });
        } else {
            if(this.fixtureData.length == 0 && this.previousPageNo == 0) {

                if(this.renderFallbackConcluded) {
                    this.soccerMatchCardContainer.innerHTML = ''
                    this.fixtureStatus = 'concluded'
                    this.currentPage = 0;
                    this.soccerTabConcludedCont.classList.add("all-sports-tab-active-container");
                    this.soccerTabUpcomingCont.classList.remove("all-sports-tab-active-container");
                    this.elementStore = {};
                    this.fixtureService.fetchFixtureData(this.sportId, this.tourId, this.fixtureStatus, this.currentPage, PRIVATE_EVENTS.FULL_PAGE_FIXTURE_UPDATE, this.jsonConfig, () => {this.handleDropDownClick(this.tourId, this.sportId, this.fixtureStatus, this.tourMetaData)});
                } else {
                    const soccerErrorContainer = this.createElement(this.soccerMatchCardContainer, "all-sports-error-container", "");
                    const soccerErrorTitle = this.createElement(soccerErrorContainer, "all-sports-error-title", "", `No ${this.fixtureStatus} matches for this tournament.`);
                    const soccerErrorSubText = this.createElement(soccerErrorContainer, "all-sports-error-subText", "", "Stay tuned for updates and announcements!");
                    if(typeof this.widgetCallback == "function"){
                        this.widgetCallback("FIXTURE_MULTI_RENDER_FAILURE", this.dropDownTourName)
                    }
                }
            }
        }

    }

    removeScrollListener = () => {
        window.removeEventListener("scroll",this.scrollHandler,true)
    }
 
    render() {
        const soccerContainerElement = document.getElementsByClassName("all-sports-container");
        if (!soccerContainerElement.length) {
            let parentContainer = document.getElementsByClassName(this.parentContainer)[0]
            const soccerContainer = this.createElement(parentContainer, "all-sports-container");
            this.soccerTopLevelCont = this.createElement(soccerContainer, "all-sports-top-level-container");
            const soccerTabViewCont = this.createElement(this.soccerTopLevelCont, "all-sports-tab-view-container");
            const soccerTabConcludedCont = this.createElement(soccerTabViewCont, "all-sports-tab-button-container all-sports-tab-concluded-container");
            this.createElement(soccerTabConcludedCont, "all-sports-tab-concluded-text", "", "Concluded");
            const soccerTabUpcomingCont = this.createElement(soccerTabViewCont, "all-sports-tab-button-container all-sports-tab-upcoming-container");
            this.createElement(soccerTabUpcomingCont, "all-sports-tab-upcoming-text", "", "Upcoming");
            if(this.fixtureStatus == 'concluded') {
                soccerTabConcludedCont.classList.add("all-sports-tab-active-container");
                soccerTabUpcomingCont.classList.remove("all-sports-tab-active-container");
            } else if(this.fixtureStatus == 'upcoming') {
                soccerTabUpcomingCont.classList.add("all-sports-tab-active-container");
                soccerTabConcludedCont.classList.remove("all-sports-tab-active-container");
            }
            if(this.fixtureDropdownData?.length > 0) {
                this.renderDropDown(this.soccerTopLevelCont)
            }
            this.soccerMatchCardContainer = this.createElement(soccerContainer, "all-sports-match-card-container");

            soccerTabConcludedCont.addEventListener("click", () => {
                if (!soccerTabConcludedCont.classList.contains('all-sports-tab-active-container')) {
                    soccerTabConcludedCont.classList.add("all-sports-tab-active-container");
                    soccerTabUpcomingCont.classList.remove("all-sports-tab-active-container");
                }
                this.soccerMatchCardContainer.innerHTML = ''
                this.fixtureStatus = 'concluded'
                this.currentPage = 0;
                this.elementStore = {};
                this.fixtureService.fetchFixtureData(this.sportId, this.tourId, this.fixtureStatus, this.currentPage, PRIVATE_EVENTS.FULL_PAGE_FIXTURE_UPDATE, this.jsonConfig, () => {this.handleDropDownClick(this.tourId, this.sportId, this.fixtureStatus, this.tourMetaData)});
            })
            soccerTabUpcomingCont.addEventListener("click", () => {
                if (!soccerTabUpcomingCont.classList.contains('all-sports-tab-active-container')) {
                    soccerTabUpcomingCont.classList.add("all-sports-tab-active-container");
                    soccerTabConcludedCont.classList.remove("all-sports-tab-active-container");
                }
                this.soccerMatchCardContainer.innerHTML = ''
                this.fixtureStatus = 'upcoming'
                this.currentPage = 0;
                this.elementStore = {};
                this.fixtureService.fetchFixtureData(this.sportId, this.tourId, this.fixtureStatus, this.currentPage, PRIVATE_EVENTS.FULL_PAGE_FIXTURE_UPDATE, this.jsonConfig, () => {this.handleDropDownClick(this.tourId, this.sportId, this.fixtureStatus, this.tourMetaData)});
            })
            
        }
        this.fixtureStatus === 'concluded'
            ? this.renderMatchCard(this.soccerMatchCardContainer, "true")
            : this.renderMatchCard(this.soccerMatchCardContainer)
    }

    scrollHandler = () => {
        let scrollContainer = document.getElementById(this.fullPageFixturesConfig?.assetConfig?.scrollContainer);
        // if (document.getElementsByClassName("inner-custom-options") && document.getElementsByClassName("inner-custom-options").length > 0) {
        //     let innerCustomOptions = document.getElementsByClassName("inner-custom-options")[0]
        //     innerCustomOptions.classList.add("display-none");
        // }
        if(document.getElementsByClassName("dropdownArrowExpand") && document.getElementsByClassName("dropdownArrowExpand").length > 0) {
            let dropDownExpand = document.getElementsByClassName("dropdownArrowExpand")[0]
            if(dropDownExpand) {
                dropDownExpand.classList.remove("dropdownArrowExpand");
            }
        }
        if(this.currentPage >= this.totalPages){
            return;
        }
        if (this.viewportDetect(scrollContainer) && !this.isLoadingMore) {
            this.isLoadingMore = true;
            this.loadMoreItems();
        }
    }

    registerPaginationOnScroll = () => {
        let scrollContainer = document.getElementById(this.fullPageFixturesConfig?.assetConfig?.scrollContainer);        
        if(scrollContainer){
            window.addEventListener('scroll', this.scrollHandler,true);
        } else {
            return
        }
    }

    viewportDetect(el) {
        var rect = el.getBoundingClientRect();
        return rect.bottom > 0 && rect.top < (window.innerHeight || document.documentElement.clientHeight);
    }

    destroy(){
        this.unSubscribeToEvents();
        this.removeScrollListener();
    }

}